<template>
  <v-btn icon :title="title" @click="onClick">
    <v-icon color="red">mdi-delete</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'DeleteIconButton',
  props: {
    title: {
      default () {
        return this.$t('general.delete');
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click');
    }
  }
}
</script>
